<template>
  <transition name="fade">
    <section class="race-select-section" :class="`race-select-section--${screenOrientationType}`">
      <div class="race-select-section__mask" @click="toggleRaceSelect" />
      <div class="race-select-section__content">
        <h3 class="race-select-section__title">{{ $t('RaceVideoPage.RaceSelect.title') }}</h3>
        <race-link-list-section @raceSelectToggle="toggleRaceSelect" />
      </div>
    </section>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import RaceLinkListSection from '@/components/RaceVideoPage/RaceVideoDataViewPane//RaceLinkListSection.vue'

/**
 * レース動画再生画面 レース選択セクションのコンポーネント
 */
export default defineComponent({
  name: 'RaceSelectSection',
  components: {
    RaceLinkListSection,
  },
  props: {
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
  },
  methods: {
    toggleRaceSelect(): void {
      /**
       * レース選択非表示化
       * @event toggleRaceSelect
       */
      this.$emit('raceSelectToggle', 'off')
    },
  },
})
</script>

<style lang="scss" scoped>
.race-select-section {
  --race-select-height: calc(var(--screen-height) - 56.25vw - 44px);

  font-size: min(3.2vw, calc(var(--screen-height) * 0.0217));
  position: relative;
  width: 100%;
  height: var(--race-select-height);
  padding-top: min(4.2667vw, 1em);
  z-index: 25;
  transition: opacity ease-in-out 0.3s;
  opacity: 1;

  &.fade-enter-active,
  &.fade-leave-active {
    pointer-events: auto;
  }

  &.fade-enter,
  &.fade-leave-to {
    opacity: 0;
    pointer-events: none;

    .race-select-section__content {
      transform: translate(100%, 0);
    }
  }

  &__mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
  }

  &__content {
    position: relative;
    width: max(calc(var(--race-select-height) * 0.46), 252px);
    margin: 0 0 0 auto;
    padding: 24px 0 24px 24px;
    height: calc(var(--race-select-height) - min(4.2667vw, 1em));
    background: $black20;
    border-radius: 8px 0 0;
    overflow-y: auto;
    transform: translate(0, 0);
    transition: all ease 0.3s;
  }

  &__title {
    margin-bottom: 20px;
    font-size: 18px;
    font-family: $fontHeading;
    line-height: 1.33;
    letter-spacing: 0.04em;
    color: #fff;
  }

  &--landscape-primary,
  &--landscape-secondary {
    --race-select-height: calc(var(--screen-height) - 44px);

    position: absolute;
    top: 44px;
    left: 0;
    right: 0;
    bottom: 0;
    height: var(--race-select-height);
    padding-top: 0;

    .race-select-section {
      &__mask {
        position: fixed;
        background: rgba(0, 0, 0, 0.4);
      }

      &__content {
        width: 100%;
        height: var(--race-select-height);
      }
    }
  }
}
</style>
<style lang="scss">
.race-video-ranking-pane {
  .race-select-section {
    position: absolute;
    top: 44px;
    left: 0;
  }
}
</style>
